import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Oval } from 'react-loader-spinner';
import api from '../services/api';
import LazyImage from '../components/LazyImage';
import { Page, Header, HeaderCard, HeaderImage, Section, Grid, Card, Thumb, Body, Pager } from './NewsStyles';

const News = () => {
  const [header, setHeader] = useState(null);
  const [posts, setPosts] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [limit] = useState(6);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;
    Promise.all([
      api.news.getHeader(),
      api.news.listPosts({ page, limit })
    ]).then(([h, list]) => {
      if (!mounted) return;
      setHeader(h);
      setPosts(list.items || []);
      setTotal(list.total || 0);
    }).catch(err => setError(err.message)).finally(() => setLoading(false));
    return () => { mounted = false; };
  }, [page, limit]);

  if (loading) return (
    <div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Oval height={48} width={48} color="#2E8B57" secondaryColor="#CDEAD7" />
    </div>
  );
  if (error) return <div style={{ padding: 20 }}>Error: {error}</div>;

  const totalPages = Math.max(1, Math.ceil(total / limit));

  return (
    <Page>
      <Header>
        <HeaderCard>
          <h1>{header?.title || 'News & Media'}</h1>
          <p>{header?.description || 'Latest updates and announcements.'}</p>
        </HeaderCard>
        <HeaderImage>
          {header?.image ? <LazyImage src={header.image} alt="News header" /> : null}
        </HeaderImage>
      </Header>

      <Section>
        <Grid>
          {posts.map(post => (
            <Card key={post._id}>
              <Link
                to={`/news/${post._id}`}
                style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
              >
                <Thumb>
                  {post.images?.[0] ? <LazyImage src={post.images[0]} alt={post.title} /> : null}
                </Thumb>
                <Body>
                  <h3>{post.title}</h3>
                  <p>{post.description?.slice(0, 120) || ''}{post.description?.length > 120 ? '…' : ''}</p>
                  <div style={{ marginTop: 8 }}>
                    <span>Read more</span>
                  </div>
                </Body>
              </Link>
            </Card>
          ))}
        </Grid>
        <Pager>
          <button disabled={page <= 1} onClick={() => setPage(p => Math.max(1, p - 1))}>Previous</button>
          <span>Page {page} of {totalPages}</span>
          <button disabled={page >= totalPages} onClick={() => setPage(p => Math.min(totalPages, p + 1))}>Next</button>
        </Pager>
      </Section>
    </Page>
  );
};

export default News;
